module.exports = __webpack_public_path__ + "static/media/SL 17.0ce24faa.mp3";